export { default } from "./capitalize.js";